require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// ../~/angular-aria/index.js
// module id = 29
// module chunks = 0 1